<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Employee</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Learning</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/job/desindex"
          >Manage Job Description</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span>Update Job Description
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-2">
         
        </div>
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="updateJob">
              <div v-if="message" class="alert alert-success py-2">
                {{ message }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger py-2">
                {{ errorMessage }}
              </div>
              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Job Title <span class="text-danger">*</span></label
                  ><input
                    v-model="jobTitle"
                    class="form-control form-control-sm bdr-rad"
                    required
                  />
                </div>
                <div class="col-md-5">
                  <label class="custom-label" style="font-size: small"
                    >Job Description <span class="text-danger">*</span></label
                  ><textarea
                    v-model="jobDescription"
                    class="form-control form-control-sm bdr-rad"
                    rows="2"
                    required
                  ></textarea>
                </div>
              </div>
              <div class="card custom_bdr_rds">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>Job Files and Links</b></h6>
                  <div class="table-responsive">
                    <table
                      style="font-size: small"
                      class="table table-sm table-hover"
                    >
                      <thead class="background_color2">
                        <tr class="custom-label2">
                          <th style="width: 50px">#</th>
                          <th>File Upload</th>
                          <th>Links</th>
                          <th style="width: 70px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in rows" :key="row.key">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <div v-if="row.file" class="current-file">
                              {{ fileName(row.file) }}
                            </div>
                            <input
                              type="file"
                              class="form-control form-control-sm bdr-rad"
                              @change="setFile($event, row)"
                            />
                          </td>
                          <td>
                            <input
                              v-model="row.link"
                              type="url"
                              class="form-control form-control-sm bdr-rad"
                            />
                          </td>
                          <td class="text-nowrap">
                            <b-icon
                              @click="removeRow(index)"
                              v-show="rows.length > 1"
                              class="ms-3 me-3 mt-2"
                              width="8"
                              type="button"
                              icon="dash-lg"
                              scale="2"
                            ></b-icon
                            ><b-icon
                              v-if="index === rows.length - 1"
                              @click="addRow"
                              class="mt-2"
                              width="8"
                              type="button"
                              icon="plus-lg"
                              scale="2"
                            ></b-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <button type="submit" class="btn btn-sm btn-outline-primary bdr-rad font-size_def">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <br /><br />
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      jobId: this.$route.query.id,
      jobTitle: "",
      jobDescription: "",
      rows: [],
      message: "",
      errorMessage: "",
    };
  },
  mounted() {
    this.loadJob();
  },
  methods: {
    newRow() {
      return {
        key: Date.now() + Math.random(),
        file: "",
        fileObject: null,
        link: "",
      };
    },
    async loadJob() {
      try {
        const { data } = await axios.get("/ticourses/jobs", {
          headers: { Authorization: "Bearer " + this.token },
        });
        const job = (data.data || []).find(
          (item) => Number(item.id) === Number(this.jobId)
        );
        if (!job) throw new Error("not found");
        this.jobTitle = job.job_title;
        this.jobDescription = job.job_description || "";
        this.rows = (job.details || []).map((detail) => ({
          key: detail.id,
          file: detail.file || "",
          fileObject: null,
          link: detail.link || "",
        }));
        this.rows.push(this.newRow());
      } catch (error) {
        this.errorMessage = "Unable to load job description.";
      }
    },
    addRow() {
      this.rows.push(this.newRow());
    },
    removeRow(index) {
      if (this.rows.length > 1) this.rows.splice(index, 1);
    },
    setFile(event, row) {
      row.fileObject = event.target.files[0] || null;
    },
    fileName(file) {
      return file.split("/").pop();
    },
    async updateJob() {
      const formData = new FormData();
      formData.append(
        "payload",
        JSON.stringify({
          job_title: this.jobTitle,
          job_description: this.jobDescription,
          rows: this.rows.map((row) => ({ file: row.file, link: row.link })),
        })
      );
      this.rows.forEach((row, index) => {
        if (row.fileObject)
          formData.append("job_files[" + index + "]", row.fileObject);
      });
      try {
        const { data } = await axios.post(
          "/ticourses/jobupdate?id=" + this.jobId,
          formData,
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.message = data.message || "Job description updated successfully.";
        this.errorMessage = "";
        setTimeout(() => this.$router.push("/job/desindex"), 500);
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Unable to update job description.";
      }
    },
    goBack() {
      this.$router.push("/job/desindex");
    },
  },
};
</script>

<style scoped>
.background_color {
  background: #eaf6ff;
  min-height: calc(100vh - 60px);
}
.background_color2 {
  background: #235983;
  color: #fff;
}
.bdr-rad {
  border-radius: 12px;
}
.bdr-rad2 {
  border-radius: 15px;
}
.decoration {
  color: #fff !important;
  text-decoration: none;
}
.font1 {
  font-size: 13px !important;
}
.manage-boder {
  background: #087df5;
  color: #fff;
  padding: 10px 15px !important;
  margin: 0 !important;
  line-height: normal;
}
.current-file {
  margin-bottom: 3px;
  color: #087df5;
}
</style>
